import { FeedbackPromptResponseDetails } from "./EmployeeFeedbackModel";
//EMNJACKA1DModel  Prompt -> On submission records get pushed to Strand.
export class EMNJACKA1DModel {
    EnterpriseId!: string;
    CardUniqueId!: string;
    FeedbackPromptComments!:string[];
    CategoryType!: string;
    ChannelType!: string;
    FeedbackPromptResponseDetails !: FeedbackPromptResponseDetails[];
    IsPostAnonymous !: boolean;
}